import { render, staticRenderFns } from "./PillsPage.vue?vue&type=template&id=36e8a53e&scoped=true&"
import script from "./PillsPage.vue?vue&type=script&lang=js&"
export * from "./PillsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8a53e",
  null
  
)

export default component.exports